import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { buttonClass } from "@/shared/ui/Button";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex max-w-lg flex-col items-start gap-1 p-6">
      <h1 className="text-xl font-semibold">{t("errors.not_found_title")}</h1>
      <p className="text-sm text-fg-muted">{t("errors.not_found_body")}</p>
      <Link to="/" className={buttonClass("secondary", "mt-3")}>
        {t("errors.home")}
      </Link>
    </div>
  );
}
